import { digitalAdoptionSaga } from './digitalAdoptionSaga';
import { buildPsmsApiPayload } from "@src/apps/psms/commonComponents/Service/psmsPayloadUtils";
import { getExtendedTinDetail } from "@src/apps/PsmsMain/Main/PsmsMainService";
import {
    PSMS_AR_SUMMARY_REQUEST,
    PSMS_AUDIT_REASON_CODE_DATA_REQUEST,
    PSMS_CALLS_CHATS_DETAILS_REQUEST,
    PSMS_CALLS_CHATS_TREND_REQUEST,
    PSMS_EVAlUATION_DETAILS_DATA_REQUEST,
    PSMS_EXTENDED_TIN_DETAIL_REQUEST,
    PSMS_FILTERS_CHANGED,
    PSMS_MCR_INVENTORY_REQUEST,
    PSMS_PA_APPROVAL_DENIAL_TREND_REQUEST,
    PSMS_PA_CASE_SUBMISSION_CHANNEL_REQUEST,
    PSMS_PA_CASE_SUBMISSION_REQUEST,
    PSMS_PA_TAT_TREND_REQUEST,
    PSMS_PAYMENT_INTEGRITY_DATA_REQUEST,
    PSMS_RECOVERY_RATES_TREND_REQUEST,
    PSMS_SETTLEMENTS_DETAILS_REQUEST,
    PSMSCLAIMS_APPEALS_TREND_DATA_REQUEST,
    PSMSCLAIMS_CLAIMS_TREND_DATA_REQUEST,
    PSMSCLAIMS_OUTCOME_REASONS_REQUEST,
    PSMSCLAIMS_RECON_DATA_REQUEST,
    PSMSCLAIMS_RECON_DETAILS_REQUEST,
    PSMSCLAIMS_SUBMISSION_REASONS_REQUEST,
    PSMSCLAIMS_TOPREASONS_DATA_REQUEST,
    PSMSCLAIMS_TOPREASONS_HEADER_DATA_REQUEST,
    PSMS_MCR_EVALUATION_DETAILS_REQUEST,
    PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_REQUEST,
    PSMS_CLAIMS_SUMMARY_REQUEST,
} from '@src/middleware/actions/actionTypes';
import { FETCH_PSMS_INDICATOR_REQUEST } from '@src/middleware/actions/actionTypes';
import { setExtendedTinDetailRequestSuccess } from "@src/middleware/actions/psms/psmsActions";
import { getPsmsState } from "@src/middleware/selectors/psms/psmsSelectors";
import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { fetchPsmsIndicator } from './psmsIndicatorSaga';
import { accountsReceivableSaga } from './accountsReceivableSaga';
import { callsChatsSaga } from './callsChatsSaga';
import claimsSaga from './claims-saga';
import { paymentIntegritySaga } from './paymentIntegritySaga';
import psmsPriorAuthSaga from './priorAuthsaga';
import viewTaxIdSaga from "./viewTaxId-saga";
import { fetchMcrInventoryFailure, fetchMcrEvaluationDetailsFailure } from '@src/middleware/actions/psms/claimActions';

function* handlePSMSFiltersChanged(action: any) {
    const filters = action.payload;
    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
    try {
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('parcelLoad'));
        }
        const psmsState = yield select(getPsmsState);
        const commonPayload = buildPsmsApiPayload(psmsState);
        const isGeoFlow = psmsState?.currentFlow === 'GEO_FLOW';

        if (pathname === '/PSMS/Claims') {
            const marketStr = Array.isArray(commonPayload.Market) && commonPayload.Market.length > 0
                ? commonPayload.Market.join('|')
                : undefined;
            const claimsPayload = {
                ...commonPayload,
                ClaimsBy: psmsState?.viewClaimsBy || 'DOS',
                Tin: commonPayload.Tins || undefined,
                Tins: undefined,
            };
            const mcrPayload = {
                ...claimsPayload,
                Market: marketStr,
            };
            const GeoMapping = isGeoFlow ? 'Provider' : undefined;
            if (psmsState?.viewClaimsBy === 'DOS') {
                if (!isGeoFlow) {
                    yield put({ type: PSMSCLAIMS_APPEALS_TREND_DATA_REQUEST, payload: claimsPayload });
                    yield put({ type: PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_REQUEST, payload: claimsPayload });
                }
                yield put({ type: PSMSCLAIMS_TOPREASONS_DATA_REQUEST, payload: { ...claimsPayload, appealsProcessing: "Received Date", DenialType: 'Full', GeoMapping, Count: 8 } });
                yield put({ type: PSMSCLAIMS_TOPREASONS_HEADER_DATA_REQUEST, payload: { ...claimsPayload, OverturnPass: "All", Type: "Volume", appealsProcessing: "Received Date" } });
                yield put({ type: PSMSCLAIMS_CLAIMS_TREND_DATA_REQUEST, payload: { ...claimsPayload, appealsProcessing: "Received Date" } });
                yield put({ type: PSMSCLAIMS_OUTCOME_REASONS_REQUEST, payload: claimsPayload });
                yield put({ type: PSMSCLAIMS_SUBMISSION_REASONS_REQUEST, payload: claimsPayload });
                yield put({ type: PSMSCLAIMS_RECON_DETAILS_REQUEST, payload: { ...claimsPayload, GeoMapping } });
                yield put({ type: PSMSCLAIMS_RECON_DATA_REQUEST, payload: { ...claimsPayload, appealsProcessing: "Received Date", GeoMapping, Type: "Volume", OverturnPass: "All" } });
            } else {
                yield put({ type: PSMSCLAIMS_TOPREASONS_DATA_REQUEST, payload: { ...claimsPayload, appealsProcessing: "Received Date", DenialType: 'Full', GeoMapping, Count: 8, ReportType: "subject" } });
                yield put({ type: PSMSCLAIMS_TOPREASONS_HEADER_DATA_REQUEST, payload: { ...claimsPayload, OverturnPass: "All", Type: "Volume", appealsProcessing: "Received Date" } });
                yield put({ type: PSMSCLAIMS_CLAIMS_TREND_DATA_REQUEST, payload: { ...claimsPayload, appealsProcessing: "Received Date" } });
            }
            yield put({ type: PSMS_CLAIMS_SUMMARY_REQUEST, payload: { ...claimsPayload, appealsProcessing: "Received Date", Type: "Volume" } });
             if (psmsState?.lob && psmsState.lob !== 'All') {
                yield put(fetchMcrInventoryFailure('No data available.'));
                yield put(fetchMcrEvaluationDetailsFailure('No data available.'));

            } else {
            yield put({ type: PSMS_MCR_INVENTORY_REQUEST, payload: mcrPayload });
            yield put({ type: PSMS_MCR_EVALUATION_DETAILS_REQUEST, payload: mcrPayload });
            }
        } else if (pathname === '/PSMS/PaymentIntegrity') {
            if (psmsState?.lob && psmsState.lob !== 'All') {
                return;
            }
            const piPayload = {
                ...commonPayload,
                Market: Array.isArray(commonPayload.Market) && commonPayload.Market.length > 0
                    ? commonPayload.Market.join('|')
                    : undefined,
                Lob: undefined,
                Tin: commonPayload.Tins || undefined,
                Tins: undefined,
            };
            yield put({ type: PSMS_PAYMENT_INTEGRITY_DATA_REQUEST, payload: piPayload });
            yield put({ type: PSMS_EVAlUATION_DETAILS_DATA_REQUEST, payload: piPayload });
            yield put({ type: PSMS_AUDIT_REASON_CODE_DATA_REQUEST, payload: piPayload });
        } else if (pathname === '/PSMS/PriorAuthorization') {
            yield put({ type: PSMS_PA_CASE_SUBMISSION_REQUEST, payload: commonPayload });
            yield put({ type: PSMS_PA_CASE_SUBMISSION_CHANNEL_REQUEST, payload: commonPayload });
            yield put({ type: PSMS_PA_APPROVAL_DENIAL_TREND_REQUEST, payload: commonPayload });
            yield put({ type: PSMS_PA_TAT_TREND_REQUEST, payload: commonPayload });
        } else if (pathname === '/PSMS/CallsAndChat') {
            yield put({ type: PSMS_CALLS_CHATS_DETAILS_REQUEST, payload: commonPayload });
            yield put({ type: PSMS_CALLS_CHATS_TREND_REQUEST, payload: commonPayload });
        } else if (pathname === '/PSMS/AccountReceivable') {
            const arPayload = {
                ...commonPayload,
                Tin: commonPayload.Tins || undefined,
                Tins: undefined,
            };
            const LOB_FULL_FORM_MAP: Record<string, string> = {
                EI: 'Commercial',
                MR: 'Medicare',
                CS: 'Medicaid',
                EXC: 'Individual Exchange'
            };
            const settlementsPayload = {
                ...arPayload,
                Lob: psmsState?.lob && psmsState.lob !== 'All'
                    ? (LOB_FULL_FORM_MAP[psmsState.lob] ?? psmsState.lob)
                    : undefined,
            };
            yield put({ type: PSMS_RECOVERY_RATES_TREND_REQUEST, payload: arPayload });
            yield put({ type: PSMS_SETTLEMENTS_DETAILS_REQUEST, payload: settlementsPayload });
            yield put({ type: PSMS_AR_SUMMARY_REQUEST, payload: arPayload });
        } else {
            // Main /PSMS landing — expandable cards each dispatch on expand,
            // nothing bulk-fired here
        }

    } catch (error) {
        console.error('❌ Error in handlePSMSFiltersChanged:', error);
    }
}

function* handleExtendedTinDetailRequest(action: any) {
    const { Tin } = action.payload;
    try {
        // Here you would typically call an API to fetch the extended TIN details
        try {
            // yield put(fetchClaimsTrendDataLoading(true));
            const response = yield call(getExtendedTinDetail, Tin);
            if (response) {
                const dataItem = response ? response : undefined;
                const filteredResponse = {
                    RegionName: dataItem[0]?.RegionName,
                    MajorMarketName: dataItem[0]?.MajorMarketName,
                    State: dataItem[0]?.State,
                    TaxIdType: dataItem[0]?.TaxIdType,
                    TinName: dataItem[0]?.TinName,
                    IsElite: dataItem[0]?.IsElite,
                    Tin: dataItem[0]?.Tin,
                    PamIndicator: dataItem[0]?.PamIndicator,
                };
                yield put(setExtendedTinDetailRequestSuccess(filteredResponse));
            }
        } catch (error) {
            console.error('❌ Error in handleExtendedTinDetailRequest:', error);
        }
    }
    finally {
        // yield put(fetchClaimsTrendDataLoading(false));
    }
}

export function* psmsSaga() {
    yield all([
        call(callsChatsSaga),
        call(claimsSaga),
        call(psmsPriorAuthSaga),
        call(viewTaxIdSaga),
        call(paymentIntegritySaga),
        call(digitalAdoptionSaga),
        call(accountsReceivableSaga),
        takeLatest(PSMS_FILTERS_CHANGED, handlePSMSFiltersChanged),
        takeLatest(PSMS_EXTENDED_TIN_DETAIL_REQUEST, handleExtendedTinDetailRequest),
        takeLatest(FETCH_PSMS_INDICATOR_REQUEST, fetchPsmsIndicator)
    ]);
}